import { type Editor } from '@tiptap/core';

import { workspaceAgentSkillMonikerInsertContent } from '~/components/v2/components/workspace/workspace-agent-panel/tiptap/workspaceAgentSkillMoniker';
import { type Skill } from '~/hooks/queries/skills/usePrivateSkillsList';

export type InsertWorkspaceAgentSkillMonikerInEditorOptions = {
  deleteRange?: { from: number; to: number };
  onInserted?: (skill: Pick<Skill, 'id' | 'scope' | 'type'>) => void;
};

export const insertWorkspaceAgentSkillMonikerInEditor = (
  editor: Editor | null | undefined,
  skill: Pick<Skill, 'id' | 'name' | 'scope' | 'slashCommand' | 'type'>,
  options?: InsertWorkspaceAgentSkillMonikerInEditorOptions,
): void => {
  if (!editor || editor.isDestroyed) {
    return;
  }

  editor.view.focus();

  if (!options?.deleteRange && !editor.state.selection.empty) {
    editor.commands.setTextSelection(editor.state.selection.to);
  }

  let chain = editor.chain().focus();

  if (options?.deleteRange) {
    chain = chain.deleteRange(options.deleteRange);
  }

  chain
    .insertContent(
      workspaceAgentSkillMonikerInsertContent({
        name: skill.name,
        skillId: skill.id,
        slashCommand: skill.slashCommand,
      }),
    )
    .scrollIntoView()
    .run();

  options?.onInserted?.(skill);
};
